import type { ShortenEventScopeType } from './ShortenEventScopeType';

// Calendar cloud setting value types as strings
export enum CalendarCloudSettingValueTypeString {
    Bool = 'Bool',
    Int = 'Int',
    String = 'String',
}

// Calendar cloud setting scope types
export enum CalendarCloudSettingScopeType {
    Global = 'global',
    Account = 'account',
}

// Calendar cloud setting value types
export type CalendarCloudSettingValueType = boolean | number | ShortenEventScopeType;
